import { Grid, Paper, Typography, FormControlLabel, Checkbox, Divider, Hidden } from '@mui/material';
import React from 'react';
import TablaHistorialEmpleadosxDepta from './TablaHistorialEmpleadosxDepta';
import BotonBuscarxDepta from './BotonBuscarxDepta';
import { obtenerlistaempresa } from '../../Redux/DepartamentosDucks'
import { obtenermenupercepciones, obtenermenumovimientos, obtenermenuincidencias, obtenermenudeducciones, obtenermenutiporiesgo, obtenermenuramoseguro, obtenermenusecuelaconsecuencia, obtenermenucontrolincapacidad } from '../../Redux/PdimMenuDucks'
import DialogoContenidorRegistroInci from '../incidencias/incidenciasregistro/DialogoContenidorRegistroInci';
import { InputBase } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MenuPerfil from '../loggin/MenuPerfil';
import ContenedorPasosDispersion from '../archivo/BotonArchivoDispersion'

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const ContenedorHistorial = (props) => {

  const { open } = props
  const { appbar } = props

  const dispatch = useDispatch()

  const [bajabusqueda, setBajabusqueda] = React.useState(true);
  const [busqueda, setBusqueda] = useState('');
  const [rows2, setRows2] = useState([]);

  const nivelpri = sessionStorage.getItem('_sr3')
  const rows = useSelector(store => store.reportes.array)

  const handleChange = e => {
    setBusqueda(e.target.value)
    filtrar(e.target.value)
  }

  const filtrar = (terminoBusqueda) => {
    var resultadoBusqueda = rows.filter((elemento) => {
      if (elemento.nombrelargo.toLowerCase().includes(terminoBusqueda.toLowerCase()) ||
        elemento.codigoempleado.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return elemento
      }
    });
    setRows2(resultadoBusqueda)
  }
  const datahistorial = busqueda === '' ? rows : rows2

  React.useEffect(() => {
    const obtenerInfo = () => {
      dispatch(obtenerlistaempresa())
      dispatch(obtenermenupercepciones())
      dispatch(obtenermenumovimientos())
      dispatch(obtenermenuincidencias())
      dispatch(obtenermenudeducciones())
      dispatch(obtenermenutiporiesgo())
      dispatch(obtenermenuramoseguro())
      dispatch(obtenermenusecuelaconsecuencia())
      dispatch(obtenermenucontrolincapacidad())
    }
    obtenerInfo()
  }, [dispatch])

  return (
    <>
      <AppBar position="absolute" color='info' open={open} elevation={0}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color='success'
            aria-label="open drawer"
            onClick={appbar}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Grid container alignItems="center">
            <Grid item sm={10} xs={10} md={9} lg={10}>
              <BotonBuscarxDepta />
            </Grid>
            <Grid item xs={2} md={2} lg={2} >

              <Hidden only='xs'>
                <MenuPerfil />
              </Hidden>
            </Grid>
          </Grid>


        </Toolbar>
        <Divider />
      </AppBar>
      <br />
      <Grid container>
        <Grid item md={7} sx={12}>
          <Typography variant='h4'>Historial de incidencias</Typography>

        </Grid>
        <Grid item md={5} sx={12}>
          <Grid container justifyContent='flex-end' direction='row' spacing={2}>
            <Grid item sx={6}>
              <DialogoContenidorRegistroInci />
            </Grid>
            {nivelpri === '13' || nivelpri === '15' ?
              <Grid item sx={6}>
                <ContenedorPasosDispersion />
              </Grid> : null
            }
          </Grid>


        </Grid>
      </Grid>

      <br /><br />

      <Grid container spacing={2} direction='row' alignItems='flex-start'>

        <Grid item xs={12} md={3}>
          <Paper
            variant='outlined'
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 'auto' }}
          ><SearchIcon color='success' />
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Buscar por Nombre o Codigo"
              inputProps={{ 'aria-label': 'Buscar por Nombre o Codigo' }}
              value={busqueda}
              onChange={handleChange}
            />

          </Paper>
        </Grid>
        <Grid item xs={12} md={6} >
          <FormControlLabel
            label="Mostrar empleados con estatus BAJA"
            labelPlacement="end"
            control={
              <Checkbox
                checked={bajabusqueda}
                onChange={e => setBajabusqueda(!bajabusqueda)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
          />
        </Grid>

      </Grid>

      <br />
     
        <TablaHistorialEmpleadosxDepta
          bajabusqueda={bajabusqueda}
          rowsdata={datahistorial}
        />
    

    </>

  )
}

export default ContenedorHistorial